
export const orderStatus = {
    NEW: "Новый",
    ADOPTED: "Принят",
    DEVELOPMENT: "Проектирование",
    DEVELOPED: "Разработан",
    PRODUCTION: "Производство",
    PRODUCED: "Произведен",
    AWAITING_SHIPMENT: "Ожидание огрузки",
    SHIPPED: "Отгружен",
    ARCHIVE: "Архив",
    NOT_IMPLEMENTED: "Не реализован",
}

/** Labels for empty values in order table multi-select filters.
 *  Parentheses only when the cell shows nothing for empty values.
 *  Without parentheses when the cell shows the same explicit text. */
export const EMPTY_STATUS_FILTER = "(без статуса)"
export const EMPTY_PLAN_FILTER = "(без плана)"
export const EMPTY_ORDER_NUMBER_FILTER = "Не занумерован"
export const EMPTY_CUSTOMER_NUMBER_FILTER = "(без № заказчика)"
export const EMPTY_CUSTOMER_FILTER = "(без заказчика)"
export const EMPTY_HEADER_FILTER = "(без наименования)"
export const EMPTY_CONSTRUCTOR_FILTER = "(без конструктора)"
export const EMPTY_TECHNOLOGIST_FILTER = "(без технолога)"
export const EMPTY_MODEL_FILTER = "(без модели)"
export const EMPTY_ATTRIBUTES_FILTER = "Не устанволен"
export const EMPTY_ATTRIBUTES_BLANK_FILTER = "(без атрибутов)"
export const EMPTY_ARCHIVE_STATE_FILTER = "(без планирования)"

export const orderStatusForCreate = {
    NEW: "Новый",
    ADOPTED: "Принят",
    DEVELOPMENT: "Проектирование",
    DEVELOPED: "Разработан",
}
